import { LOGGED_IN_USER_ID_KEY } from '../storage/StorageConstants';

class CommonDAO {
  static getLoggedInUserId(): string | null {
    return (localStorage.getItem(LOGGED_IN_USER_ID_KEY)) || '0';
  }

  static setLoggedInUserId(id: string): void {
    localStorage.setItem(LOGGED_IN_USER_ID_KEY, id);
  }

  static clearLoggedInUserId(): void {
    localStorage.removeItem(LOGGED_IN_USER_ID_KEY);
  }
}

export default CommonDAO;